import { useMutation, UseMutationOptions } from 'react-query'
import { ApiClient } from 'services/ApiClient'
import { Api } from 'types/Api'

export namespace CreatePassword {
  export type Response = any
  export type Variables = { password: string }
  export type Error = Api.Error
  export type Options = UseMutationOptions<Response, Error, Variables>
}

export const useCreatePassword = (jwt: string, options?: CreatePassword.Options) => {
  const headers = {
    Authorization: `Bearer ${jwt}`,
  }

  const mutationFn = async (data: CreatePassword.Variables) => {
    return ApiClient.patch<CreatePassword.Response>('/v1/clients/password/reset', {
      data,
      headers,
    })
  }

  const mutation = useMutation<
    CreatePassword.Response,
    CreatePassword.Error,
    CreatePassword.Variables
  >(mutationFn, options)

  return { ...mutation, createPassword: mutation.mutate }
}
